<template>
  <div class="base">
    <inside-header title="发布文章" />
    <div class="main">
      <a-form :form="form" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }" @submit="handleSubmit">
        <a-form-item label="文章标题">
          <a-input v-decorator="[
          'title',
          {
            initialValue: info.title,
            rules: [{ required: true, message: '请输入文章标题' }]
          }]" />
        </a-form-item>
        <a-form-item label="文章内容">
          <a-textarea v-decorator="['content',
          {
            initialValue: info.content,
            rules: [{ required: true, message: '请输入内容' }]
          }]" :rows="5" />
        </a-form-item>
        <a-form-item label="文章主题" :wrapper-col="{ span: 8 }">
          <a-input v-decorator="['talk_subject',
          {
            initialValue: info.talk_subject,
            rules: [{ required: true, message: '请输入相关主题' }]
          }]" />
        </a-form-item>
        <a-form-item label="发布形式" :wrapper-col="{ span: 8 }">
          <a-radio-group v-decorator="['status',
          {
            initialValue: info.status,
            rules: [{ required: true, message: '选择发布形式' }]
          }]">
            <a-radio :value="1">
              公开
            </a-radio>
            <a-radio :value="2">
              私密
            </a-radio>
            <a-radio :value="4">
              存为草稿
            </a-radio>
          </a-radio-group>
        </a-form-item>
        <a-form-item>
          <a-button class="submit-btn" type="primary" html-type="submit">
            提交
          </a-button>
        </a-form-item>
      </a-form>
    </div>
    <main-footer />
  </div>
</template>
<script>
import { MainFooter, InsideHeader } from '@/components'
import Vue from 'vue'
import { Switch } from 'vant'
Vue.use(Switch)
export default {
  name: 'TutorPay',
  components: {
    MainFooter,
    InsideHeader
  },
  props: {
    id: {}
  },
  data() {
    return {
      loading: true,
      state: {
        postBtn: false
      },
      form: this.$form.createForm(this, { name: 'article-post' }),
      pageType: '',
      info: {}
    }
  },
  created() {
    if (this.id === undefined) {
      this.loading = false
      this.pageType = 'add'
    } else {
      this.pageType = 'edit'
      this.loadData(this.id)
    }
  },
  methods: {
    loadData(id) {
      this.loading = true
      this.$http({
        url: '/index/my_forum/info',
        method: 'get',
        params: {
          id: id
        }
      }).then(res => {
        this.loading = false
        if (res.status === 'success') {
          const data = res.data
          this.info = data.info
          console.log(data)
        } else {
          this.$notification.error({
            message: '系统繁忙，请刷新重试',
            description: ''
          })
        }
      })
    },
    handleChange(value) {
      console.log(`selected ${value}`)
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFieldsAndScroll((err, values) => {
        if (!err) {
          var uri = ''
          // 判断状态
          if (this.pageType === 'add') {
            uri = '/index/my_forum/create'
          } else {
            values.id = this.id
            uri = '/index/my_forum/save'
          }
          this.state.postBtn = true
          this.$http({
            url: uri,
            method: 'post',
            data: values
          }).then(res => {
            this.state.postBtn = false
            if (res.status === 'success') {
              this.$toast.success('文章提交成功')
              const that = this
              // 跳转到工单列表页
              setTimeout(function () {
                that.$router.push({ name: 'UserMyArticle' })
              }, 2000)
            } else {
              this.$toast.fail(res.message)
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
  .base {
    min-width: 280px;
    max-width: 420px;
    margin: auto;
    background-color: #fff;
  }

  .main {
    padding: 15px;

  }

  .submit-btn {
    width: 90px;
    height: 40px;
  }

  .draft-btn {
    width: 90px;
    height: 40px;
    margin-left: 20px;
  }
</style>
